import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { UserType } from "~/components/template/video/Meet"
import { CompanyType } from "~/model/Company"
import { AccountCondition } from "~/pages/management/accounts"
import type { RootState } from "~/store"

/**

 */

type TemporaryData = {
  blcId: string
  signInStatus: number
  redirectRoute: {
    pathname: string
    query: object
  }
  form: {
    [KEY in string]: any
  }
  accountCondition: AccountCondition
  userType: UserType
  workflowObj: any
}
const initialData = (): TemporaryData => ({
  blcId: null,
  signInStatus: 0,
  redirectRoute: null,
  form: {},
  accountCondition: {
    companyType: CompanyType.MANAGEMENT,
    page: 1,
    limit: 10,
  },
  userType: UserType.GUEST,
  workflowObj: {},
})

export const temporarySlice = createSlice({
  name: "temporary",
  initialState: initialData(),
  reducers: {
    setSignInStatus: (state, action) => {
      //   const { font, color } = action.payload
      //   state.font = font
      state.signInStatus = action.payload
    },
    setForm: (state, action) => {
      const [key, data] = action.payload
      state.form[key] = data
    },
    clearForm: (state, action) => {
      const key = action.payload
      delete state.form[key]
    },
    clearAllForm: (state) => {
      state.form = {}
    },
    clear: (state) => {
      state.signInStatus = 0
      state.redirectRoute = null
    },
    setRedirect: (state, action) => {
      state.redirectRoute = action.payload
    },
    setBlcId: (state, action) => {
      state.blcId = action.payload
    },
    setAccountCondition: (state, action: PayloadAction<AccountCondition>) => {
      state.accountCondition = action.payload
    },
    setUserType: (state, action: PayloadAction<UserType>) => {
      state.userType = action.payload
    },
    setWorkflowObj: (state, action) => {
      state.workflowObj = action.payload
    },
  },
})
export const {
  setSignInStatus,
  setForm,
  clearForm,
  clearAllForm,
  clear,
  setRedirect,
  setBlcId,
  setAccountCondition,
  setUserType,
  setWorkflowObj,
} = temporarySlice.actions
export const selectTemporary = (state: RootState) => state.temporary
export default temporarySlice.reducer
